module.exports = __webpack_public_path__ + "static/media/country_cu.9b482212.webp";